import { render } from "./OrderTracking.vue?vue&type=template&id=0d5d24b2"
import script from "./OrderTracking.vue?vue&type=script&lang=js"
export * from "./OrderTracking.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__